/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const a=["any","capture","upload"];export{a as mediaInputArray};
